// 足球 联赛 CSL|中超 => FBL(足球联赛缩写)CSL
export default {
  data() {
    return {
      containerFullClassName: 'containerFull_football_CSL',
      defaultPath: ['football', 'FBLCSL', 'schedule'],
      axiosBaseUrl: '/ftleague', // '/csl',
      sportCompetitionType: 'footballLeague_FBLCSL', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
    }
  },
}
